'use strict';

var $ = require('core-utils/modules/jquery-extend');
require('bootstrap-notify/bootstrap-notify');
var gtxConstants = require('gtx-constants');

/**
 * Oggetto wrapper del componente Bootstrap Notify
 * http://bootstrap-notify.remabledesigns.com/
 * @syntax var gtxNotify = require('gtx-notify'); gtxNotify.success({message:'foo bar'})
 */
var GtxNotify = (function () {

    
    var styleClasses = {
            success: {
                icon:'#check-circle',
                type: '--success'
            },
            danger: {
                icon:'#cross-circle',
                type: '--error'
            },
            warning: {
                icon:'#exclamation-mark-circle',
                type: '--warning'
            },
            info: {
                icon:'#info-circle',
                type: '--info'
            }
        },
        custom,
        danger,
        info,
        issetDefaults = false,
        root,
        success,
        warning,
        _getDataByType,
        _notify;

    _notify = function (options, settings) {

        // Compose Template with icons and other variabled
        settings.template = '<div data-notify="container" class="gx-notify">' +
        '<div class="gx-alert gx-alert{0}" role="alert">'+
        '<svg class="gx-icon gx-icon{0}"><use xlink:href="' + gtxConstants('ICONS_SVG_SPRITE_FILE_PATH') + options.icon + '"></use></svg>' +
        '<span data-notify="message">{2}</span>' +
        '</div>'+
        '</div>';

        if (!issetDefaults) {
            $.notifyDefaults({
                delay: 3000,
                timer: 500,
                'z_index': 9999,
                'allow_dismiss': false,
                placement: {
                    from: 'top',
                    align: 'center',
                    css: {
                        display: 'flex'
                    }
                },
                offset: 0,
                animate: {
                    enter: 'gx-animated gx-slideInDown',
                    exit: 'gx-animated gx-slideOutUp'
                }
            });

            issetDefaults = true;
        }

        $.notify(options, settings);

    };

    _getDataByType = function (type) {
        return styleClasses[type];
    };

    success = function (options) {
        var opt = options || {},
            settings = {},
            data = _getDataByType('success');

        opt.icon = data.icon;
        settings.type = data.type;

        _notify(opt, settings);
    };

    danger = function (options) {
        var opt = options || {},
            settings = {},
            data = _getDataByType('danger');

        opt.icon = data.icon;
        settings.type = data.type;

        _notify(opt, settings);
    };

    info = function (options) {
        var opt = options || {},
            settings = {},
            data = _getDataByType('info');

        opt.icon = data.icon;
        settings.type = data.type;

        _notify(opt, settings);
    };

    warning = function (options) {
        var opt = options || {},
            settings = {},
            data = _getDataByType('warning');

        opt.icon = data.icon;
        settings.type = data.type;

        _notify(opt, settings);
    };

    custom = function (options, settings) {
        if (settings.standardType) {
            var data = _getDataByType(settings.standardType);

            options.icon = data.icon;
            settings.type = data.type;
        }

        _notify(options, settings);
    };

    root = {
        custom: custom,
        danger: danger,
        info: info,
        success: success,
        warning: warning
    };

    return root;

})();

module.exports = GtxNotify;
